const namespace = 'FileForm';

export const EDIT_MULTIPLE_FILES_REQUEST = `${namespace}/EDIT_MULTIPLE_FILES_REQUEST`;
export const EDIT_MULTIPLE_FILES_FAILURE = `${namespace}/EDIT_MULTIPLE_FILES_FAILURE`;
export const EDIT_MULTIPLE_FILES_SUCCESS = `${namespace}/EDIT_MULTIPLE_FILES_SUCCESS`;
